module.exports = __webpack_public_path__ + "static/media/reviews.1a101755.svg";